/* Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';

const CSATNumberSvg = (
  index
) => {

  let fillColor = '';
  switch(index) {
    case 1:
      fillColor = '#E75527';
      break;
    case 2:
      fillColor = '#F4963E';
      break;
    case 3:
      fillColor = '#FFCC48';
      break;
    case 4:
      fillColor = '#68C8C8';
      break;
    case 5:
      fillColor = '#68C87D';
      break;
    default:
      break;
  }
  return (
    <svg width="1.5em" height="1.5em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill={fillColor} />
      <text
        x="50%"
        y="50%"
        text-anchor="middle"
        dominant-baseline="middle"
        fill={'#ffffff'}
        fontSize={'1em'}
      >
        {index}
      </text>

    </svg>
  );
};

export const CSATNumberIcon = ({ index, ...props }) => (
  <Icon component={() => CSATNumberSvg(index)} {...props} />
);

CSATNumberIcon.propTypes = {
  index: PropTypes.number
};
